/**
 * Created by Victor Rojo on 1/9/17.
 */
import { Component, OnInit }        from '@angular/core';
import { FormGroup, FormControl,
         FormBuilder, Validators }  from '@angular/forms';
import { ActivatedRoute }           from '@angular/router';
import { NotificationsService }     from 'angular2-notifications';

import { AuthService }  from '../auth.service';
import { Credential }   from "../credential";
import { I18NService }  from "../../i18n/i18n.service";

@Component({
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.css'],
})
export class PasswordResetComponent implements OnInit{

  passwordResetForm: FormGroup;
  isBusy = false;
  public toastOptions = {
    position: ["top", "right"],
    timeOut: 3000,
    theClass: "bg-teal",
    lastOnBottom: true,
    showProgressBar: true,
    pauseOnHover: false,
  };
  private token:string;
  private login:string;
  customization = '';
  tenant = '';

  constructor(private fb: FormBuilder,
              private authService: AuthService,
              private activatedRoute: ActivatedRoute,
              private i18nService: I18NService,
              private notificationService: NotificationsService) {
    let pattern = /^[A-Za-z0-9\S\*]*$/;
    this.passwordResetForm = fb.group({
      'password' : [null, Validators.compose([Validators.required, Validators.minLength(6), Validators.pattern(pattern)])],
    })

    if ( document.location.hostname  == "galp.cloud.ipetrol.es") {
      this.customization = "galp ipetrol";
      this.tenant = "galp";
    } else if ( document.location.hostname  == "ask.cloud.ipetrol.es" ) {
      this.customization = "ask ipetrol";
      this.tenant = "ask";
    } else if ( document.location.hostname  == "ecuador.cloud.ipetrol.es" ) {
      this.customization = "ecuador ipetrol";
      this.tenant = "ecuador";
    } else if ( document.location.hostname  == "q8.cloud.ipetrol.es" ) {
      this.customization = "q8 ipetrol";
      this.tenant = "q8";
    } else if ( document.location.hostname  == "ecomanager.cloud.ipetrol.es" ) {
      this.customization = "ecomanager ipetrol";
      this.tenant = "ecomanager";
    } else if ( document.location.hostname  == "cloud.ipetrol.es") {
      this.customization = "ipetrol";
      this.tenant = "";
    } else if ( document.location.hostname  == "hiotera.cloud.iplace.es" ) {
      this.customization = "hiotera";
      this.tenant = "hiotera";
    }  else if ( document.location.hostname  == "nacexa.cloud.iplace.es" ) {
      this.customization = "nacexa";
      this.tenant = "nacexa";
    } else if ( document.location.hostname  == "geo4radon.cloud.iplace.es" ) {
      this.customization = "geo4radon";
      this.tenant = "geo4radon";
    } else if ( document.location.hostname  == "freeenergia.cloud.iplace.es" ) {
      this.customization = "freeenergia";
      this.tenant = "freeenergia";
    } else if ( document.location.hostname  == "kontrolwat.cloud.iplace.es" ) {
      this.customization = "kontrolwat";
      this.tenant = "kontrolwat";
    } else if ( document.location.hostname  == "respira.cloud.iplace.es" ) {
      this.customization = "respira";
      this.tenant = "respira";
    } else if ( document.location.hostname  == "iotino.cloud.iplace.es" ) {
      this.customization = "iotino";
      this.tenant = "iotino";
    } else if ( document.location.hostname  == "depourense.cloud.iplace.es" ) {
      this.customization = "depourense";
      this.tenant = "depourense";
    } else if ( document.location.hostname == "h2h.cloud.iplace.es" ) {
      this.customization = "h2h";
      this.tenant = "h2h";
    } else if ( document.location.hostname == "hacsuite.cloud.iplace.es" ) {
      this.customization = "hacsuite";
      this.tenant = "hacsuite";
    } else if ( document.location.hostname == "smartpadel.cloud.iplace.es" ) {
      this.customization = "smartpadel";
      this.tenant = "smartpadel";
    }
  }

  ngOnInit():void {
    this.token = this.activatedRoute.snapshot.queryParams["token"];
    this.login = this.activatedRoute.snapshot.queryParams["login"];
  }

  passwordReset():void{
    let data = {
      password: this.passwordResetForm.controls["password"].value,
      token: this.token
    };
    if ( this.passwordResetForm.valid ) {
      this.isBusy = true;
      this.authService.passwordReset(data)
        .then(res => {
          let credential = new Credential(this.login, data.password);
          this.authService.login(credential, false)
            .then( response => {
              this.isBusy = false;
            })
            .catch(error => {
              this.isBusy = false;
            });
          this.isBusy = false;
        })
        .catch( error => {
          this.isBusy = false;
          this.notificationService.error(
            this.i18nService.get("error"),
            this.i18nService.get("cantResetPassword")
          );
        });
    }
  }
}
